module.exports = __webpack_public_path__ + "img/图片1.662234af.jpg";